import store from '../store';

export default class Folder {
  constructor(api) {
    this.api = api
  }

  list() {
    return this.api.call_busy({
      '_class': 'Folder',
      '_method': 'list',
    }).then(folders => {
      const foldersMap = {}

      // TODO: validation
      folders = folders.folder
      ? this._parseFolders(folders.folder, foldersMap)
      : []
      store.commit('setFolders', { folders, foldersMap })
    })
  }

  create(name, type, folder=null) {
    if (folder && folder.id) {
      return this.api.call_busy({
        '_class': 'Folder',
        '_method': 'create',
        'name': name,
        'type': type,
        'parent_id': folder.id,
      })
    } else {
      return this.api.call_busy({
        '_class': 'Folder',
        '_method': 'create',
        'name': name,
        'type': type,
      })
    }
  }

  rename(id, name) {
    return this.api.call_busy({
      '_class': 'Folder',
      '_method': 'update',
      'id': id,
      'name': name
    })
  }

  delete(id) {
    return this.api.call_busy({
      '_class': 'Folder',
      '_method': 'delete',
      'id': id,
      'force': 1
    })
  }

  update(id, parent_id) {
    return this.api.call_busy({
      '_class': 'Folder',
      '_method': 'update',
      'id': id,
      'parent_id': parent_id
    })
  }

  _parseFolders(folders, foldersMap) {
    let res = []
    if (!folders.length) {
      folders = [folders]
    }
    for (const i in folders) {
      let folder = folders[i]._attributes
      if (folders[i].folder) {
        folder.children = this._parseFolders(folders[i].folder, foldersMap)
      }
      res.push(folder)
      foldersMap[folder.id] = folder
    }
    return res
  }
}